import { extractAttributes } from '@vlabs/api/luna-api/client';
import { confirmDuplicateFace } from '@vlabs/pages/point/cards/confirm-duplicate-face';
import { getSimilarityThresholds } from '@vlabs/shared/config/similarityThresholds';

export const checkCardFaceDuplicates = async ({
  cardId,
  sampleId,
}: {
  cardId: string;
  sampleId: string;
}): Promise<void> => {
  const sdkDescriptor = await extractAttributes([sampleId], {
    extract_descriptor: 1,
  });
  const { medium: threshold } = getSimilarityThresholds();
  await confirmDuplicateFace({
    // referenceFaceSrc: getSample('faces', sampleId),
    references: [{
      id: sdkDescriptor?.[0]?.attribute_id,
      type: 'attribute',
    }],
    candidates: [{
      filters: {
        origin: 'faces',
        external_ids: [cardId],
      },
      limit: 100,
      threshold: threshold ?? 95,
    }],
    onReject: () => {
      throw new Error('User rejected duplicate face confirmation');
    },
  });
};
